"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4124],{

/***/ 46998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);

/* harmony default export */ __webpack_exports__["Z"] = ({
    name: "Jeff E.",
    jobDescription: "Software Application Specialist Mechanical or Industrial Engineering",
    color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white
});


/***/ }),

/***/ 16438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PersonTextualInfo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/person-textual-info/person-textual-info.scss.js

var StyledPersonTextualInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1w2qszs0"
})("font-size:1.125rem;line-height:30px;.person-name{font-weight:700;}@media (max-width:720px){font-size:1rem;line-height:30px;}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/default-props.js
var default_props = __webpack_require__(46998);
;// CONCATENATED MODULE: ./segments/desktop/core-components/person-textual-info/person-textual-info.js









var PersonTextualInfo = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PersonTextualInfo, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PersonTextualInfo);
    function PersonTextualInfo() {
        (0,_class_call_check/* default */.Z)(this, PersonTextualInfo);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PersonTextualInfo, [
        {
            key: "getTextualInfoStyle",
            value: function getTextualInfoStyle() {
                var color = this.props.color;
                return {
                    color: color
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, name = _props.name, jobDescription = _props.jobDescription, className = _props.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPersonTextualInfo, {
                    className: classnames_default()("person-textual-info", className),
                    style: this.getTextualInfoStyle(),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "person-name",
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "seperator",
                            children: " | "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "person-job-description",
                            children: jobDescription
                        })
                    ]
                });
            }
        }
    ]);
    return PersonTextualInfo;
}(react.PureComponent);

PersonTextualInfo.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 69799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PlainClassicTestimonialsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/plain-classic-testimonials/plain-classic-testimonials-component.scss.js


var BIG_SCREEN_PADDING = 70;
var BIG_SCREEN_MAX_WIDTH = vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld - BIG_SCREEN_PADDING;
var MEDIUM_SCREEN_PADDING_TOP_BOTTOM = 70;
var StylesPlainClassicTestimonialsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewbuith0"
})("max-width:", BIG_SCREEN_MAX_WIDTH, "px;margin:auto;padding-left:", BIG_SCREEN_PADDING, "px;padding-right:", BIG_SCREEN_PADDING, "px;.testimonial-card-wrapper{height:100%;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){max-width:100vw;padding:", MEDIUM_SCREEN_PADDING_TOP_BOTTOM, "px 0;}");

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/person-textual-info.js + 1 modules
var person_textual_info = __webpack_require__(16438);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/default-props.js
var default_props = __webpack_require__(46998);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/components/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ var components_default_props = (_object_spread_props(_object_spread({
    theme: "iris",
    quote: "“Huge Collaborative Projects, or Daily Personal To-Do's: monday.com Can Change Your Life!“"
}, default_props/* default */.Z), {
    companyImage: "/static/img/customers/discovery.png"
}));

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/components/testimonial-card-component.scss.js




var CONTENT_MAX_WIDTH = 710;
/* harmony default export */ var testimonial_card_component_scss = (/*#__PURE__*/(0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emb7yrz0"
})("position:relative;height:100%;padding:56px 48px;display:flex;justify-content:center;align-items:center;.company-image-wrapper{position:absolute;width:180px;height:68px;overflow:hidden;left:50%;top:0;transform:translateX(-50%) translateY(-50%);border-radius:8px;border:", "1px solid ".concat(colors/* default.riverstone */.Z.riverstone), ";", (0,constants.getComponentShadow)(), "    background-color:", colors/* default.white */.Z.white, ";.picture-component{width:100%;height:100%;img{width:100%;}}}.testimonial-card-content-wrapper{max-width:", "".concat(CONTENT_MAX_WIDTH, "px"), ";text-align:center;.quote-wrapper{margin-bottom:24px;font-size:2.75rem;font-weight:700;line-height:60px;&.xs{font-size:1.375rem;line-height:32px;font-weight:400;}&.sm{font-size:1.75rem;line-height:40px;font-weight:400;}&.md{font-size:2.25rem;line-height:48px;font-weight:400;}&.lg{font-size:2.75rem;line-height:60px;font-weight:700;}&.lgr{font-size:3.375rem;line-height:68px;font-weight:700;}&.xl{font-size:4rem;line-height:72px;font-weight:700;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.testimonial-card-content-wrapper{.quote-wrapper{font-size:1.75rem !important;// overide inline styles\n        line-height:50px;&.md,&.lg,&.xl{font-size:1.75rem !important;line-height:40px;font-weight:700;}}}}"));

;// CONCATENATED MODULE: ./segments/desktop/testimonials/components/testimonial-card-component.js












var TestimonialCardComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TestimonialCardComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TestimonialCardComponent);
    function TestimonialCardComponent() {
        (0,_class_call_check/* default */.Z)(this, TestimonialCardComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TestimonialCardComponent, [
        {
            key: "getThemeStyle",
            value: function getThemeStyle() {
                var theme = this.props.theme;
                return segments_service/* themes */.np[theme] || {};
            }
        },
        {
            key: "getQuoteInlineStyle",
            value: function getQuoteInlineStyle() {
                var _props = this.props, fontSize = _props.fontSize, titleSize = _props.titleSize;
                var inlineStyles = {};
                if (!titleSize) inlineStyles.fontSize = fontSize;
                return inlineStyles;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, quote = _props.quote, name = _props.name, jobDescription = _props.jobDescription, companyImage = _props.companyImage, titleSize = _props.titleSize, alt = _props.alt;
                var themeStyle = this.getThemeStyle();
                var quoteInlineStyle = this.getQuoteInlineStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(testimonial_card_component_scss, {
                    className: "testimonial-card-component",
                    style: themeStyle,
                    children: [
                        companyImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "company-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                src: companyImage,
                                alt: alt
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "testimonial-card-content-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("quote-wrapper", titleSize),
                                    dangerouslySetInnerHTML: {
                                        __html: quote
                                    },
                                    style: quoteInlineStyle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "person-details-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(person_textual_info/* default */.Z, {
                                        name: name,
                                        jobDescription: jobDescription,
                                        color: themeStyle.color
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return TestimonialCardComponent;
}(react.PureComponent);

TestimonialCardComponent.defaultProps = components_default_props;

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/plain-classic-testimonials/plain-classic-testimonials-component.js




function plain_classic_testimonials_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function plain_classic_testimonials_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            plain_classic_testimonials_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function plain_classic_testimonials_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function plain_classic_testimonials_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        plain_classic_testimonials_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var PlainClassicTestimonialsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PlainClassicTestimonialsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PlainClassicTestimonialsComponent);
    function PlainClassicTestimonialsComponent() {
        (0,_class_call_check/* default */.Z)(this, PlainClassicTestimonialsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PlainClassicTestimonialsComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, testimonialCard = _props.testimonialCard, fontSize = _props.fontSize, titleSize = _props.titleSize;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesPlainClassicTestimonialsComponent, {
                    className: "plain-classic-testimonials-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "testimonial-card-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCardComponent, plain_classic_testimonials_component_object_spread_props(plain_classic_testimonials_component_object_spread({}, testimonialCard), {
                            fontSize: fontSize,
                            titleSize: titleSize
                        }))
                    })
                });
            }
        }
    ]);
    return PlainClassicTestimonialsComponent;
}(react.PureComponent);

PlainClassicTestimonialsComponent.defaultProps = {
    testimonialCard: TestimonialCardComponent.defaultProps,
    paddingTop: "70px",
    paddingBottom: "70px",
    titleSize: sizes.LG
};


/***/ })

}]);